export default "__VITE_ASSET__d5f9d6ff__"